import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { getGalleryPending } from 'store/entities/gallery/selectors'
import { increaseLazyLoaded } from 'store/entities/gallery/actions'

import GalleryItems from 'app/components/Gallery/GalleryItems'

const mapStateToProps = createStructuredSelector({
  pending: getGalleryPending,
})

const mapDispatchToProps = {
  increaseLazyLoaded,
}
export default connect(mapStateToProps, mapDispatchToProps)(GalleryItems)
